import React, { useContext } from 'react';
import { Heading } from '@thd-olt-component-react/core-ui';
import { bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { imageBaseUrl } from '../../constants';
import { MenuBar, MenuBarItem } from './menuBar/MenuBarComponent';

export const PrivacyHeader = ({
  overviewActive, privacyInformationActive, submitARequestActive, contactUsActive, fraudCenterActive
}) => {

  const { channel } = useContext(ExperienceContext);

  const getMenuBarClasses = () => {
    return channel === 'mobile'
      ? 'menu-bar__white--mobile'
      : 'menu-bar__white';
  };

  return (
    <div className="cdg-content--header menu-bar__sticky">
      <Heading className="cdg-header">
        <img
          height="40"
          width="40"
          alt="Privacy ToolBox"
          src={imageBaseUrl + '/PrivacyToolbox_logo_CLR.svg'}
          style={{ marginRight: '10px' }}
        />
        Privacy & Security Center
      </Heading>
      <MenuBar classNames={getMenuBarClasses()}>
        <MenuBarItem
          title="Overview"
          link="/privacy/overview"
          active={overviewActive}
          label="Open Overview to read about privacy"
        />
        <MenuBarItem
          title="Privacy Information"
          link="/privacy/privacy-and-security-at-a-glance"
          active={privacyInformationActive}
          label="Open for more info on Home Depot's privacy"
        />
        <MenuBarItem
          title="Fraud & Security"
          link="/privacy/Fraud-Center"
          active={fraudCenterActive}
          label="Open for more information about the Fraud Center"
        />
        <MenuBarItem
          title="Submit a Request"
          link="/privacy/Exercise-My-Privacy-Rights"
          active={submitARequestActive}
          label="Select to fill out our privacy request form"
        />
        <MenuBarItem
          title="Contact Us"
          link="/privacy/privacy-and-security-at-a-glance#HowToContactUs"
          active={contactUsActive}
          label="Open to get options to contact us"
        />
      </MenuBar>
    </div>
  );
};

PrivacyHeader.propTypes = {
  overviewActive: bool,
  privacyInformationActive: bool,
  submitARequestActive: bool,
  contactUsActive: bool,
  fraudCenterActive: bool
};

PrivacyHeader.defaultProps = {
  overviewActive: false,
  privacyInformationActive: false,
  submitARequestActive: false,
  contactUsActive: false,
  fraudCenterActive: false
};
